module.exports = __webpack_public_path__ + "media/images/front/top/slideArw-c07b37604a58e967d014e414f65eef89.png";